import { configureStore } from '@reduxjs/toolkit';
import loginReducer from '../slices/auth/login/reducer';
// import crmReducer from "./crmSlice";

import DashboardReducer from "../slices/dashboard/reducer"
// import other reducers as needed

export const store = configureStore({
  reducer: {
    Login: loginReducer,
    Dashboard: DashboardReducer
    
    // add other slices here
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
